export const actions = {};

function resolvePendingActionState(actionName, pendingPromise, newActionState) {
    const currentAction = actions[actionName];
    const isPending = currentAction.state === 'pending';
    const isPendingPromise = currentAction.promise === pendingPromise;

    if (isPending && isPendingPromise) {
      actions[actionName] = {
        id: currentAction.id,
        ...newActionState,
      };
    }
}

let nextActionId = 0;
function resetAction(actionName) {
  actions[actionName] = {
    state: 'ready',
    pending: false,
    failed: false,
  };
  nextActionId += 1;
}

function onSuccess(actionName, pendingPromise) {
  return (result) => {
    resolvePendingActionState(actionName, pendingPromise, {
      state: 'ready',
      pending: false,
      failed: false,
    });

    return result;
  };
}

function onError(actionName, pendingPromise, retryAction) {
  return (err) => {
    const errors = Array.isArray(err) ? err : [err];

    // TODO: attempt to resolve the actual error message?

    resolvePendingActionState(actionName, pendingPromise, {
      state: 'failed',
      pending: false,
      failed: true,
      errors,
      retry: retryAction,
      reset: () => resetAction(actionName),
    });

    throw err;
  };
}


export function wrapAction(actionName, action) {
  resetAction(actionName);

  return function lifecycleWrappedAction(...args) {
    const resultPromise = (async () => action(...args))();

    actions[actionName] = {
      id: nextActionId,
      state: 'pending',
      pending: true,
      failed: false,
      promise: resultPromise,
      cancel: () => resetAction(actionName),
    };
    nextActionId += 1;

    // Retry should execute this function with the same args that were originally passed.
    const retry = () => lifecycleWrappedAction(...args);

    return resultPromise.then(
      onSuccess(actionName, resultPromise),
      onError(actionName, resultPromise, retry),
    );
  };
}
